import { createFileRoute, redirect } from "@tanstack/react-router";

// The Chatbase comparison now lives in the unified, translatable comparison
// system at /vs/chatbase. Permanent redirect preserves any existing links and
// avoids duplicate content.
export const Route = createFileRoute("/vs-chatbase")({
  beforeLoad: () => {
    throw redirect({ to: "/vs/$slug", params: { slug: "chatbase" }, statusCode: 301 });
  },
});
